import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import { DialogAnnouncementComponent } from "../dialog-announcement/dialog-announcement.component";
import Announcement from "../../models/announcement.model";
import { AnnouncementService } from "../../services/announcement.service";
import { Subject } from "rxjs";

@Component({
  selector: "ngx-view-announcements",
  styleUrls: ["./view-announcements.component.scss"],
  templateUrl: "./view-announcements.component.html",
})
export class ViewAnnouncementsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = "admin"; //admin / course / home
  @Input() courseId?: string = "";

  submitted = false;
  loading = false;
  cursor: any;
  done = false;

  display?: Announcement[] = [];
  announcements?: Announcement[] = [];

  pageSize = 3;
  strSearch = "";
  uid = "";

  constructor(
    private announcementService: AnnouncementService,
    public userService: UserService,
    private dialogService: NbDialogService,
    private router: Router
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
      });

    if (this.mode == "home") {
      this.getHomeAnnouncements();
    } else {
      this.getAnnouncements();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getMore(): void {
    this.pageSize = 12;
    this.getAnnouncements();
  }

  close() {}

  //Control event lazyloading qna announcement
  onSearch(): void {
    this.strSearch = this.strSearch.toLowerCase();

    this.display = this.announcements.filter(
      function (item) {
        return (
          item.title.toLowerCase().includes(this.strSearch) ||
          item.description.toLowerCase().includes(this.strSearch)
        );
      },
      { strSearch: this.strSearch }
    );
  }

  onNew() {
    let fbNew = new Announcement();
    fbNew.priority = "info";
    fbNew.courseId = this.courseId ? this.courseId : "";
    fbNew.category = this.courseId != "" ? "course" : "system";

    this.dialogService
      .open(DialogAnnouncementComponent, {
        context: {
          header: "Tạo thông báo",
          mode: "new",
          announcement: fbNew,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value && value.status == 1) {
          this.announcements = [value, ...this.announcements];
          this.display = [...this.announcements];
        }
      });
  }

  onEdit(item: Announcement) {
    if (item) {
      for (let i = 0; i < this.announcements.length; i++) {
        if (this.announcements[i].id == item.id) {
          this.announcements[i] = item;
          break;
        }
      }
      this.display = [...this.announcements];
    }
  }

  onDelete(value) {
    if (value) {
      remove(this.announcements, (e) => {
        return e.id == value;
      });
      this.display = [...this.announcements];
    }
  }

  private getHomeAnnouncements(): void {
    this.loading = true;

    this.announcementService
      .getHomeAnnouncements()
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        this.display = data;
        this.loading = false;
      });
  }

  private getAnnouncements(): void {
    this.loading = true;

    let subscribe: any;
    if (this.mode == "admin") {
      subscribe = this.announcementService.getAnnouncements(
        this.pageSize,
        this.cursor
      );
    } else if (this.courseId && this.courseId != "") {
      subscribe = this.announcementService.getCourseAnnouncements(
        this.courseId,
        this.pageSize,
        this.cursor
      );
    } else {
      subscribe = this.announcementService.getPublishedAnnouncements(
        this.pageSize,
        this.cursor
      );
    }

    subscribe
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          this.cursor = querySnapshot.docs[querySnapshot.docs.length - 1];

          querySnapshot.forEach((doc) => {
            let data = new Announcement();
            data = doc.data();
            data.id = doc.id;
            data.createdOn = convertTimestamp(doc.data().createdOn);
            if (data.startDate) {
              data.startDate = convertTimestamp(data.startDate);
            }
            if (data.endDate) {
              data.endDate = convertTimestamp(data.endDate);
            }

            let item = find(this.announcements, ["id", data.id]);
            if (item) {
              item = data;
            } else {
              this.announcements.push(data);
            }
          });

          this.display = [...this.announcements];
        } else {
          this.cursor = null;
          this.done = true;
        }

        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  }
}
